import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnInit,
  AfterViewInit
} from "@angular/core";

@Component({
  selector: 'animated-digit',
  templateUrl: './animate-digit.component.html',
  styleUrls: ['./animate-digit.component.scss']
})
export class AnimateDigitComponent implements OnInit, AfterViewInit {
  @Input() delaytime: number;   //sec
  @Input() digit: string;
  @Input() stoptime: Date;
  @Input() seldigit: number = 0;
  @ViewChild("animatedDigit", { static: true }) animatedDigit: ElementRef;

  lotNum: number = 0;
  timeTask: any;
  _stopTime: Date;
  spintime: number;

  ngOnInit(): void {
    if (!this.delaytime) {
      this.delaytime = 0;
    }

    if (isNaN(parseInt(this.digit)))
      this.digit = '0';
    else {
      this.digit = this.digit.substring(this.seldigit, this.seldigit + 1);
    }

    if (this._stopTime && this._stopTime.getTime() < new Date().getTime()) {
      this.lotNum = parseInt(this.digit);
    } else {
      this.lotNum = Math.trunc(Math.random() * 10);
    }
    this.counterFunc();
  }

  ngAfterViewInit(): void {
  }

  SetStopTime(lot: string, sttime: Date) {
    if ((this._stopTime && this._stopTime.getTime() > sttime.getTime()) || /^\*+$/.test(lot)) {
      return;
    }
    if (!sttime)
      this._stopTime = new Date();
    else
      this._stopTime = new Date(sttime.getTime() + 5000);

    if (isNaN(parseInt(lot))) return;
    this.digit = lot.substring(this.seldigit, this.seldigit + 1);
    if ((this._stopTime.getTime() > new Date().getTime()) && this.delaytime) {
      // this.lotNum = Math.trunc(Math.random() * 10);
      this.lotNum = this.seldigit;
    }
    else {
      this.lotNum = parseInt(this.digit);
    }
    this._stopTime.setSeconds(this._stopTime.getSeconds() + this.delaytime);
    this.counterFunc();
  }

  counterFunc() {
    if (this.timeTask)
      return;
    this.timeTask = setInterval(() => {
      let ct = new Date().getTime();
      if (this._stopTime && this._stopTime.getTime() < ct) {
        clearInterval(this.timeTask);
        this.timeTask = null;
        if (isNaN(parseInt(this.digit))) return;
        if (this.digit.length > 1) {
          this.digit = this.digit.substring(this.seldigit, this.seldigit + 1);
        }
        this.lotNum = parseInt(this.digit);
        return;
      }

      this.lotNum++;
      if (this.lotNum > 9)
        this.lotNum = 0;

    }, 120);

  }

  isFinished(): boolean {
    return !this.timeTask;
  }
}
